import axios from "axios";

export const BULLETIN_REQUEST = "BULLETIN_REQUEST";
export const BULLETIN_ERROR = "BULLETIN_ERROR";
export const FETCH_BULLETINS_SUCCESS = "FETCH_BULLETINS_SUCCESS";
export const CREATE_BULLETIN_SUCCESS = "CREATE_BULLETIN_SUCCESS";
export const UPDATE_BULLETIN_SUCCESS = "UPDATE_BULLETIN_SUCCESS";
export const DELETE_BULLETIN_SUCCESS = "DELETE_BULLETIN_SUCCESS";

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const getAuthHeaders = () => {
    try {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        return user?.role ? { 'x-user-role': user.role } : {};
    } catch {
        return {};
    }
};

// FETCH ALL BULLETINS (Centralized)
export const fetchBulletins = (params = {}) => async (dispatch) => {
    dispatch({ type: BULLETIN_REQUEST });
    try {
        const res = await axios.get(`${API_BASE_URL}/api/bulletins/get-bulletins`, { params });
        const list = Array.isArray(res.data?.data) ? res.data.data : [];
        const normalized = list.map(item => ({
            ...item,
            id: item._id || item.id
        }));
        dispatch({ type: FETCH_BULLETINS_SUCCESS, payload: normalized });
        return res.data;
    } catch (error) {
        console.error("fetchBulletins error:", error);
        dispatch({ type: BULLETIN_ERROR, payload: error.message });
        throw error;
    }
};

// CREATE BULLETIN (Owner only)
export const createBulletin = (formData) => async (dispatch) => {
    dispatch({ type: BULLETIN_REQUEST });
    try {
        const res = await axios.post(`${API_BASE_URL}/api/bulletins/create-bulletin`, formData, {
            headers: getAuthHeaders()
        });
        const created = res.data?.data ? { ...res.data.data, id: res.data.data._id || res.data.data.id } : formData;
        dispatch({ type: CREATE_BULLETIN_SUCCESS, payload: created });
        return res.data;
    } catch (error) {
        console.error("createBulletin error:", error);
        dispatch({ type: BULLETIN_ERROR, payload: error.message });
        throw error;
    }
};

// UPDATE BULLETIN (Owner only)
export const updateBulletin = (id, formData) => async (dispatch) => {
    dispatch({ type: BULLETIN_REQUEST });
    try {
        const res = await axios.put(`${API_BASE_URL}/api/bulletins/update-bulletin/${id}`, formData, {
            headers: getAuthHeaders()
        });
        const updated = res.data?.data ? { ...res.data.data, id: res.data.data._id || id } : { ...formData, id };
        dispatch({ type: UPDATE_BULLETIN_SUCCESS, payload: updated });
        return res.data;
    } catch (error) {
        console.error("updateBulletin error:", error);
        dispatch({ type: BULLETIN_ERROR, payload: error.message });
        throw error;
    }
};

// DELETE BULLETIN (Owner only)
export const deleteBulletin = (id) => async (dispatch) => {
    dispatch({ type: BULLETIN_REQUEST });
    try {
        await axios.delete(`${API_BASE_URL}/api/bulletins/delete-bulletin/${id}`, {
            headers: getAuthHeaders()
        });
        dispatch({ type: DELETE_BULLETIN_SUCCESS, payload: id });
    } catch (error) {
        console.error("deleteBulletin error:", error);
        dispatch({ type: BULLETIN_ERROR, payload: error.message });
        throw error;
    }
};
